import RestService from '../../contracts/RestService';
import { httpClient } from '../../utils/http-client';
export default class ThumbDraftService extends RestService {
    uri = 'thumbdrafts';
    getDraft = (id) => {
        return this.client.get(`${this.uri}/${id}`);
    };
    getVideoDrafts = (id) => {
        return this.client.get(`${this.uri}/?videoid=${id}&isDrafts=true`);
    };
    requestedClips = (id) => {
        return this.client.get(`${this.uri}/?videoid=${id}`);
    };
    getUncompleted = () => {
        return this.client.get(`${this.uri}/uncompleted`);
    };
    markAllCompleted = () => {
        return this.client.post(`${this.uri}/completeall/`);
    };
    markCompleted = (id) => {
        return this.client.patch(`${this.uri}/completed/${id}`);
    };
    markIncomplete = (id) => {
        return this.client.patch(`${this.uri}/incomplete/${id}`);
    };
    makeProject = (id, projectName) => {
        return this.client.patch(`${this.uri}/makeproject/${id}`, { projectName });
    };
    getProjects = (videoId) => {
        return this.client.get(`${this.uri}/projects/${videoId}`);
    };
    async rename(id, data) {
        return (await httpClient.patch(`${this.uri}/rename/${id}`, data)).data;
    }
}
let thumbServiceInstance = null;
export let getThumbService = () => {
    if (!thumbServiceInstance) {
        thumbServiceInstance = new ThumbDraftService();
    }
    return thumbServiceInstance;
};
